module.exports = __webpack_public_path__ + "img/device-full-screen.4c2dd9c8.svg";